import { format, parseISO } from 'date-fns';

const defaultPattern = 'yyyy-MM-dd';

export const formatDateToString = (date: Date, pattern?: string): string =>
  format(date, pattern || defaultPattern);

export const formatDateFromString = (date: string, pattern?: string): string =>
  date ? format(parseISO(date), pattern || defaultPattern) : '';
